export type FileCategory = 'image' | 'video' | 'document';

const IMAGE_EXTENSIONS = ['JPG', 'JPEG', 'PNG', 'GIF', 'WEBP', 'BMP', 'SVG'];
const VIDEO_EXTENSIONS = ['AVI', 'MP4', 'MOV', 'MKV', 'WEBM'];

/**
 * Extension of the file name, uppercased. Empty when the name carries none.
 */
const getExtension = (fullName: string): string => {
  const dotIndex = fullName.lastIndexOf('.');
  if (dotIndex > 0 && dotIndex < fullName.length - 1) {
    return fullName.slice(dotIndex + 1).toUpperCase();
  }
  return '';
};

/**
 * Coarse category used to pick the icon. Driven by the mime type reported by the backend,
 * with a fallback to the extension: the SSE snapshot and files stored before the type was
 * tracked come without it.
 */
export const getFileCategory = (type: string | undefined, fullName: string): FileCategory => {
  if (type?.startsWith('image/')) {
    return 'image';
  }
  if (type?.startsWith('video/')) {
    return 'video';
  }
  if (!type) {
    const extension = getExtension(fullName);
    if (IMAGE_EXTENSIONS.includes(extension)) {
      return 'image';
    }
    if (VIDEO_EXTENSIONS.includes(extension)) {
      return 'video';
    }
  }
  return 'document';
};

/**
 * Short label shown next to the file name: the extension when the name carries one,
 * otherwise the mime subtype.
 */
export const getFileLabel = (fullName: string, type?: string): string => {
  const extension = getExtension(fullName);
  if (extension) {
    return extension;
  }
  const subtype = type?.split('/')[1];
  return subtype ? subtype.toUpperCase() : '';
};
